import { render, staticRenderFns } from "./AtomInfoPrice.vue?vue&type=template&id=cc4ee978&"
import script from "./AtomInfoPrice.vue?vue&type=script&lang=js&"
export * from "./AtomInfoPrice.vue?vue&type=script&lang=js&"
import style0 from "./AtomInfoPrice.vue?vue&type=style&index=0&id=cc4ee978&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
